<template>
  <div style="overflow-y: auto; overflow-x:hidden;">
    <v-card max-width="300" class="mx-auto my-4 subproject-card">
      <!-- Títutlo -->
      <v-card-title>{{ title }}</v-card-title>

      <!-- Imagen -->
      <v-img
        :lazy-src="image"
        :src="image"
        height="200px"
        width="100%"
        class="white--text align-end"
        gradient=""
        cover
      >
        <template v-slot:placeholder>
          <div class="d-flex align-center justify-center fill-height">
            <v-progress-circular
              color="grey-lighten-4"
              indeterminate
            ></v-progress-circular>
          </div>
        </template>
      </v-img>

      <!-- Subtítulo -->
      <v-card-subtitle class="text-h6">
        {{ subtitle }}
      </v-card-subtitle>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "SubprojectCard",
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true,
    },
    subproject: {
      type: Object,
      required: true,
    },
  },
  computed: {
    image() {
      return this.$store.state.project_users?.find(u => u.email === this.subproject.userOwner[0])?.avatar || this.$store.state.defaultAvatar;
    }
  },
}
</script>

<style scoped>
.subproject-card{
  background-color: #0083749a;
  user-select: none;
  cursor: pointer;
  transition: transform 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  overflow: hidden;
  color: #fff;
}

.subproject-card:hover {
  transform: scale(1.05);
}
</style>